import { AUTHENTICATION_CLICK_SIGNUP } from './events';

export const loggedOutMixpanelEvents = [AUTHENTICATION_CLICK_SIGNUP];
